var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2007_3470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 3H20.0001V0.999939C20.0001 0.448059 19.552 0 18.9999 0H18C17.4479 0 17.0001 0.448059 17.0001 0.999939V3H6.99994V0.999939C6.99994 0.448059 6.55206 0 6 0H5.00006C4.448 0 3.99994 0.448059 3.99994 0.999939V3H3C1.34601 3 0 4.34601 0 6V21C0 22.654 1.34601 24 3 24H21C22.654 24 24 22.654 24 21V6C24 4.34601 22.654 3 21 3ZM21.9999 21C21.9999 21.551 21.551 21.9999 21 21.9999H3C2.44904 21.9999 2.00006 21.551 2.00006 21L2 8.5H21.9999V21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1929 19.091C10.3659 19.3259 10.632 19.4741 10.9229 19.4969C10.9489 19.499 10.9749 19.5001 11 19.5001C11.2639 19.5001 11.5189 19.3961 11.707 19.2069L17.4569 13.457C17.848 13.0659 17.848 12.434 17.4569 12.0431C17.0659 11.652 16.434 11.652 16.0429 12.0431L11.117 16.969L9.056 14.1591C8.72897 13.7139 8.10293 13.6171 7.65799 13.9439C7.21304 14.2709 7.11599 14.897 7.44302 15.3419L10.1929 19.091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2007_3470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.af91e466dbfc57a62d650cc00e76a4d8.svg";
export { ForwardRef as ReactComponent };